import { useCallback, useState } from "react";
import { errorMessage, syncStock } from "../services/blingService";

const MAX_BATCHES = 2000;

// Envia o estoque do site (fonte da verdade) para o Bling, produto a produto
// (cursor), com progresso done/total.
export function useBlingStockSync() {
  const [syncing, setSyncing] = useState(false);
  const [processed, setProcessed] = useState(0);
  const [updated, setUpdated] = useState(0);
  const [remaining, setRemaining] = useState(null);
  const [errors, setErrors] = useState([]);

  const start = useCallback(async () => {
    setSyncing(true);
    setProcessed(0);
    setUpdated(0);
    setRemaining(null);
    setErrors([]);
    try {
      let after = null;
      for (let batch = 0; batch < MAX_BATCHES; batch++) {
        const result = await syncStock(after, 1);
        setProcessed((n) => n + (result.processed || 0));
        setUpdated((n) => n + (result.updated || 0));
        setErrors((prev) => [...prev, ...(result.errors || [])]);
        setRemaining(result.remaining);
        if (!result.remaining || !result.next) break;
        after = result.next;
      }
    } catch (err) {
      setErrors((prev) => [...prev, { code: "—", error: errorMessage(err) }]);
    } finally {
      setSyncing(false);
    }
  }, []);

  return { syncing, processed, updated, remaining, errors, start };
}
